<template>
    <div class="app-container">
        <div class="row">
            <div class="user-information">
                <h1>Limitler ve Engellemeler</h1>
                <div class="main-space" v-for="lim in limitations" :key="lim.name">
                    <div class="sheet-l float-left">
                        <span class="main-header">{{ lim.name }}</span>
                    </div>
                    <div class="sheet-r float-right">&nbsp;</div>
                    <div class="limit" v-for="limit in lim.limits" :key="limit.key">
                        <div class="sheet-l float-left">
                            {{ t.limitations.type[limit.key] }}
                        </div>
                        <div class="sheet-r float-right">{{ limit.limit }}</div>
                    </div>
                </div>
                <div class="hr bg-darkgrey clear"></div>
            </div>
            <div class="asideBox-block">
                <div class="post-box">
                    <div class="post-content text-left">
                        <h6 class="post-title">
                            Diger Onerilerimiz
                        </h6>
                        <ul class="postBox-list">
                            <li class="postBox-item casinoSidebar">
                                <a>Casino</a>
                            </li>
                            <li class="postBox-item liveCasinoSidebar">
                                <a>Canli Casino</a>
                            </li>
                            <li class="postBox-item virtualSidebar">
                                <a>Sanal Spor</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="post-box">
                    <div class="post-content text-left">
                        <h6 class="post-title">
                            Haftanin Kazananlari
                        </h6>
                        <ul class="postBox-list topWinner-list">
                            <li class="postBox-item topWinner blue">
                                <a>Ju...n</a>
                                <span>5.271,51 €</span>
                            </li>
                            <li class="postBox-item topWinner">
                                <a>Ma...s</a>
                                <span>5.271,51 €</span>
                            </li>
                            <li class="postBox-item topWinner">
                                <a>Br...o</a>
                                <span>5.271,51 €</span>
                            </li>
                            <li class="postBox-item topWinner">
                                <a>Jo...o</a>
                                <span>5.271,51 €</span>
                            </li>
                            <li class="postBox-item topWinner">
                                <a>Ra...l</a>
                                <span>5.271,51 €</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="post-box">
                    <div class="post-content text-left">
                        <h6 class="post-title">
                            Mobile
                        </h6>
                        <div class="mobile-image">
                            <img src="/static/assets/img/rivalo/mobileqr-code.png" alt="mobile-qr">
                        </div>
                        <div class="mobileBox-text">
                            <div>Access the complete betting program from the palm of your hands!</div>
                            <div class="fakeLink">Click here for Mobile</div>
                        </div>
                        <p></p>
                    </div>
                </div>
            </div>
            <div class="betslip-block">
                <BetSlip ref="BetSlip"/>
            </div>
        </div>
    </div>
</template>

<script>
    import BetSlip from '@/components/sportsbook/BetSlip';

    export default {
        name: "limits",
        components: {BetSlip},
        data() {
            return {
                t: this.$root.t,
                limitations: null
            }
        },
        mounted() {
            this.fetchLimitations();
        },
        methods: {
            fetchLimitations() {
                this.$http.get(api + 'api/v1/limitations')
                    .then(response => {


                        this.limitations = response.body.result.limitations;
                    }, response => {

                    })
            }
        }
    }
</script>

<style scoped>

    .bg-grey {
        background: #ebebeb;
    }

    .bg-darkgrey {
        background: #999999;
    }

    .clear {
        clear: both;
    }

    .hr {
        height: 1px;
        background-repeat: repeat-x;
        overflow: hidden;
        margin: 0;
    }

    .user-information {
        width: 64%;
        float: left;
        margin: 0 10px;
        background: #fff;
        display: inline-block;
        box-sizing: border-box;
        padding: 0;
        height: fit-content;
    }

    .user-information h1 {
        padding: 12px 0 4px 12px;
        margin-bottom: 10px;
        color: #003366;
        border-bottom: 3px solid #003366;
        font-size: 15px;
        line-height: 20px;
    }

    .sheet-l {
        width: 25%;
        height: 24px;
        line-height: 24px;
        color: #666;
        text-align: right;
        padding-right: 20px;
        font-size: 11px;
    }

    .sheet-r {
        width: 75%;
        min-height: 24px;
        line-height: 24px;
        font-size: 12px;
        color: #000;
    }

    .sheet-l .main-header {
        color: #000;
        font-weight: bold;
    }

    .button-main {
        width: 180px;
        padding-right: 12px;
        min-height: 1px;
        position: relative;
    }

    .button-180.grey {
        width: 180px;
        height: 24px;
        cursor: pointer;
        background: #3c3c3c;
        padding-bottom: 2px;
        margin: 10px 0 10px 10px;
        line-height: 22px;
    }

    .button-180 {
        font-size: 14px;
        text-decoration: none;
        display: block;
        color: white;
        text-align: center;
    }

    .button-180:hover {
        color: #ef8107;
    }

    .limit:nth-child(2n+1) .sheet-l,.limit:nth-child(2n+1) .sheet-r {
        background: #ebebeb;
    }
</style>


// WEBPACK FOOTER //
// src/components/user/limits.vue